import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { Box, Loader } from "@strapi/design-system"
import App from "./App"
import Initializer from "./components/Initializer/Initializer"
import "./main.css"
import { persistor, store } from "store/store"
import "./translations/i18n.ts"
import queryClient from "providers/queryClient"
import { QueryClientProvider } from "@tanstack/react-query"
import * as Sentry from "@sentry/react"
import { isDevelopment, typedEnv } from "./config/typedEnv"

if (!isDevelopment)
  Sentry.init({
    dsn: "https://b80d4819e2e6b4d7d8db700231d19e12@o1346587.ingest.us.sentry.io/4508805588910080",
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [/\.sentry\.io$/],
    environment: typedEnv.VITE_SENTRY_ENV,
    beforeSend(event, hint) {
      const error = hint.originalException
      if (error instanceof Error && error.message.startsWith("HTTP error:")) {
        return null
      }
      return event
    },
  })

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <PersistGate
      loading={
        <Box
          style={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader />
        </Box>
      }
      persistor={persistor}
    >
      <link rel="stylesheet" href="./css/app.css" />
      <Initializer>
        <React.StrictMode>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </React.StrictMode>
      </Initializer>
    </PersistGate>
  </Provider>
)
